export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20reading%20scene%20with%20multiple%20comic%20books%20and%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20soft%20natural%20lighting%2C%20wooden%20desk%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20inviting%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=600&seq=about-manga-01&orientation=landscape"
              alt="歪歪漫画网平台介绍"
              className="w-full h-auto rounded-lg"
            />
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">关于歪歪漫画网</h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                歪歪漫画网是一个专注为漫画爱好者打造的免费在线阅读平台，致力于提供歪歪漫画网站入口与歪歪漫画免费网站入口的便捷访问体验。我们聚合了全网最丰富的日漫、韩漫与国漫大全资源，覆盖热血、恋爱、奇幻、悬疑、搞笑、耽美等多种题材，满足不同读者的口味需求。
              </p>
              <p>
                平台采用创新的下拉式全集阅读模式，读者只需纵向滑动即可连续阅读完整漫画，无需频繁翻页或等待加载。所有漫画内容均支持在线免费观看，无需注册登录，无需任何付费，真正做到永久免费畅看。
              </p>
              <p>
                我们的编辑团队每日追踪日韩热门连载动态，第一时间同步更新最新话内容，确保读者追更不等待。无论是寻找好看的韩漫、经典日漫回顾，还是探索国产漫画新作，歪歪漫画网都是您最便捷的在线漫画阅读入口。
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-6">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-accent-100 text-accent-700 text-sm font-medium rounded-md whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i>
                5000+ 漫画资源
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-secondary-100 text-secondary-700 text-sm font-medium rounded-md whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i>
                每日同步更新
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-primary-100 text-primary-700 text-sm font-medium rounded-md whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i>
                永久免费阅读
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}